import Vue from 'vue'
import { usrActions, usrGetters } from '@/store/user.module'

Object.defineProperty(Vue.prototype, '$user', { value: { usrGetters, usrActions } })
/**************** Authorizations   **********************/
Object.defineProperty(Vue.prototype, '$isAuthorized', { value: usrGetters.getScopeRight })